import { createFileRoute } from '@tanstack/react-router';

/** A new chat before its first message; the layout route renders the page. */
export const Route = createFileRoute('/_app/admin/agent/_chat/new')({});
